import type { ResultHistory } from '../../../../services/MedicalResultsService';
import type { DimensionDatum } from './hooks/useFetchDimensionData';

/**
 * When GET /history returns no rows but GET /results (v3) already attached Observations on the
 * dimension (`dimension.resources`), synthesize ResultHistory rows so Lab Results / InlineRangeView
 * can render instead of NoDataGuard's "Not available".
 */
export function buildResultHistoryFallbackFromV3(
  datum: DimensionDatum,
): ResultHistory[] {
  const { resources } = datum.dimension;
  const baseCode = datum.dimension.codes[0];
  if (!resources?.length || !baseCode) {
    return [];
  }

  const systems = (datum.systems ?? []).map(s => ({
    code: s.code ?? '',
    system: s.system ?? '',
    display: s.display,
  }));

  return resources.map((resource, index) => {
    const oc = resource.code?.coding?.[0];
    return {
      type: 'withoutRange' as const,
      resource: resource as fhir3.Observation,
      source: datum.resultSources?.[index],
      coding: {
        code: baseCode.key ?? oc?.code ?? '',
        system: baseCode.system ?? oc?.system ?? '',
        display: baseCode.display ?? oc?.display ?? resource.code?.text ?? '',
      },
      systems,
      subSystems: [],
      aboutText: '',
      aiGenerated: false,
      result: {
        status: 'default' as const,
        text: '',
        interpretationText: '',
      },
    };
  });
}
